module.exports = __webpack_public_path__ + "static/media/userAvatar.928d5da9.svg";